// src/services/gpsService.js
import axios from "axios";

const GPS_BASE_URL = "https://api.gpsbinhminh.vn/Vehicle";

// username thực tế = "61h06971" + EM SPACE (U+2003)
const GPS_USERNAME = "61h06971\u2003";
const GPS_PASSWORD = "12345";

export const GpsService = {
  async getMyVehicleStatus() {
    const params = new URLSearchParams({
      pageIds: 245,
      username: GPS_USERNAME, // sẽ encode thành %E2%80%83 đúng như URL anh test
      pwd: GPS_PASSWORD,
    });

    const url = `${GPS_BASE_URL}/GpsInfos?${params.toString()}`;
    console.log("URL gọi GPS:", url); // để anh tự check nó có %E2%80%83

    const res = await axios.get(url);
    return res.data;
  },
};
